<template>
	<page-content bgClass="bg-#0E0E0E" :triggered="triggered" :more="more" needMore @scrolltolower="scrolltolower"
		@refresherpulling="refresherpulling">
		<template v-slot:navBar>
			<home-nav title="NUT" :showLang="true"></home-nav>
		</template>
		<template v-slot:content>
			<div class="px-30 pt-20 pb-140">
				<div class="mt-20 destroy-team-item1-bg-image rounded-20 p-30">
					<div class="flex items-center justify-between">
						<div class="ml-20 flex-1">
							<div class="flex items-center justify-between">
								<span class="text-36 text-white">{{$t('NUT.奖励.我的奖励总览')}}</span>
							</div>
						</div>
					</div>
					<div class="mt-30 flex items-center justify-between">
						<div class="rounded-20 px-40 py-30 flex-1 mr-10" style="background-color: #2D2D2F;">
							<div>
								<span class="text-20 text-white">{{$t('NUT.奖励.可领取奖励')}}</span>
							</div>
							<div class="mt-20 flex items-center">
								<span class="text-36 text-white font-bold">1,420.5</span>
							</div>
							<div class="mt-10">
								<span class="text-20 text-success">+12.5%</span>
							</div>
						</div>
						<div class=" rounded-20 px-40 py-30 flex-1 ml-10" style="background-color: #2D2D2F;">
							<div>
								<span class="text-20 text-white">{{$t('NUT.奖励.已领取总额')}}</span>
							</div>
							<div class="mt-20 flex items-center">
								<span class="text-36 text-white font-bold">799.7 ROON</span>
							</div>
							<div class="mt-10">
								<span class="text-20 text-success">≈$999.63</span>
							</div>
						</div>
					</div>
				</div>
				<div class=" my-30 flex items-center justify-between rounded-22 h-90 bg-white/10">
					<div @click="setQueryInfo(1)" :class="[queryInfo.type == 1 ? 'bg-primary' : '']"
						class="rounded-22 flex-1 h-90 flex items-center justify-center">
						<span class="text-28 text-white">{{$t('NUT.奖励.税收分红')}}</span>
					</div>
					<div @click="setQueryInfo(2)" :class="[queryInfo.type == 2 ? 'bg-primary' : '']"
						class="rounded-22 flex-1 h-90 flex items-center justify-center">
						<span class="text-28 text-white">{{$t('NUT.奖励.持币分红')}}</span>
					</div>
					<div @click="setQueryInfo(3)" :class="[queryInfo.type == 3 ? 'bg-primary' : '']"
						class="rounded-22 flex-1 h-90 flex items-center justify-center">
						<span class="text-28 text-white">{{$t('NUT.奖励.LP奖励')}}</span>
					</div>
					<div @click="setQueryInfo(4)" :class="[queryInfo.type == 4 ? 'bg-primary' : '']"
						class="rounded-22 flex-1 h-90 flex items-center justify-center">
						<span class="text-28 text-white">{{$t('NUT.奖励.NFT分红')}}</span>
					</div>
				</div>
				<!-- 税收分红 -->
				<div v-if="queryInfo.type == 1" class="">
					<div class="rounded-20 p-30" style="background-color: #19191A;">
						<div class="flex items-center justify-between">
							<span class="text-36 text-white">{{$t('NUT.奖励.税收分红领取')}}</span>
							<div class="px-20 h-42 rounded-12 flex items-center justify-center border border-solid"
								style="border-color:#0DF018; background-color: #0DF01820;">
								<span class="text-20 text-white">{{$t('NUT.奖励.盈利税+砸盘税')}}</span>
							</div>
						</div>
						<div class="mt-20 rounded-20 p-30" style="background-color: #0F0F10;">
							<div class=" flex items-center">
								<img class="w-76 h-76" src="@/assets/images/pages/nut-reward/ydsfh.png" alt="" />
								<div class="ml-20 flex-1 flex items-center justify-between ">
									<span class="text-26 text-white">{{$t('NUT.奖励.盈利税分红')}}</span>
									<span class="text-28 font-bold" style="color: #18E72B;">20%{{$t('NUT.奖励.回购')}}</span>
								</div>
							</div>
							<div class="mt-20">
								<span class="text-44 text-white font-bold">85.6 ROON</span>
							</div>
						</div>
						<div class="mt-20 rounded-20 p-30" style="background-color: #0F0F10;">
							<div class=" flex items-center">
								<img class="w-76 h-76" src="@/assets/images/pages/nut-reward/zpfh.png" alt="" />
								<div class="ml-20 flex-1 flex items-center justify-between ">
									<span class="text-26 text-white">{{$t('NUT.奖励.砸盘税分红')}}</span>
									<span class="text-28 font-bold" style="color: #3CFFC5;">20%{{$t('NUT.奖励.回购')}}</span>
								</div>
							</div>
							<div class="mt-20">
								<span class="text-44 text-white font-bold">85.6 ROON</span>
							</div>
						</div>
						<div class="mt-20 rounded-20 p-30" style="background-color: #0F0F10;">
							<div class=" flex items-center justify-between">
								<span class="text-28 text-#999">{{$t('NUT.奖励.总可领取')}}</span>
								<span class="text-40 text-white font-bold">127.9 ROON</span>
							</div>
							<div class="mt-30 px-20 h-60 rounded-12 flex items-center justify-center border border-solid"
								style="border-color:#EB470C; background-color: #EB470C20;">
								<img class="w-24 h-24" src="@/assets/images/pages/nut-reward/ts.png" alt="" />
								<span class="ml-20 text-20 text-primary">{{$t('NUT.奖励.领取时50%销毁，50%到账')}}</span>
							</div>
						</div>
						<div class="mt-20 bg-white/10 rounded-20 p-30" style="background-color: #0F0F10;">
							<div class="mb-20">
								<span class="text-white text-36">{{$t("NUT.奖励.税收机制说明")}}</span>
							</div>
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("NUT.奖励.盈利税20%:回购ROON分红给参与者")}}</span>
							</div>
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("NUT.奖励.盘税25%:每日8点AVE价格为准，跌1%扣2%")}}</span>
							</div>
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("NUT.奖励.最高下跌12.5%时税率达25%")}}</span>
							</div>
						</div>
						<div class="mt-40 flex items-center justify-center pb-30">
							<div class="w-630 h-100 bg-primary rounded-full flex items-center justify-center">
								<span class="text-32 text-white font-bold">{{$t('NUT.奖励.领取税收分红')}}</span>
							</div>
						</div>
					</div>

				</div>
				<!-- 持币分红 -->
				<div v-else-if="queryInfo.type == 2" class="">
					<div class="rounded-20 p-30" style="background-color: #19191A;">
						<div class="flex items-center justify-between">
							<span class="text-36 text-white">{{$t('NUT.奖励.持币分红')}}</span>
							<div class="px-20 h-42 rounded-12 flex items-center justify-center border border-solid"
								style="border-color:#0DF018; background-color: #0DF01820;">
								<span class="text-20 text-white">0.5%{{$t('NUT.奖励.手续费')}}</span>
							</div>
						</div>
						<div class="mt-20 rounded-20 p-30" style="background-color: #0F0F10;">
							<div class="flex items-center justify-between ">
								<span class="text-26 text-white">{{$t('NUT.奖励.可领取')}}</span>
								<span class="text-28 text-success">{{$t('NUT.奖励.下次分红')}}2小时15分</span>
							</div>
							<div class="mt-40">
								<span class="text-44 text-white font-bold">125.5 ROON</span>
							</div>
							<div class="mt-30">
								<span class="text-24 text-white">{{$t('NUT.奖励.已领取')}}： 450.2 ROON</span>
							</div>
						</div>
						<div class="mt-20 rounded-20 flex items-center justify-between">
							<span class="text-28 text-#999">{{$t('NUT.奖励.参与条件')}}</span>
							<span class="text-28 text-#999">{{$t('NUT.奖励.持有')}} ≥ 100,000 NUT</span>
						</div>
						<div class="mt-20 rounded-20 flex items-center justify-between">
							<span class="text-28 text-#999">{{$t('NUT.奖励.领取费用')}}</span>
							<span class="text-28 text-primary">50% NUT{{$t('NUT.奖励.价值')}}</span>
						</div>
						<div class="mt-30 px-20 h-60 rounded-12 flex items-center justify-center border border-solid"
							style="border-color:#EB470C; background-color: #EB470C20;">
							<img class="w-24 h-24" src="@/assets/images/pages/nut-reward/ts.png" alt="" />
							<span class="ml-20 text-20 text-primary">{{$t('NUT.奖励.领取时50%销毁，50%到账')}}</span>
						</div>
						<div class="mt-40 flex items-center justify-center mb-20">
							<div class="w-630 h-100 bg-primary rounded-full flex items-center justify-center">
								<span class="text-32 text-white">{{$t('NUT.奖励.领取奖励')}}</span>
							</div>
						</div>
					</div>
				</div>
				<!-- LP奖励 -->
				<div v-else-if="queryInfo.type == 3" class="">
					<div class="bg-white/10 rounded-20 p-30">
						<div class="flex items-center justify-between">
							<span class="text-36 text-white">{{$t('NUT.奖励.LP贡献奖励')}}</span>
							<div class="px-20 h-42 rounded-12 flex items-center justify-center border border-solid"
								style="border-color:#50B428; background-color: #50B42820;">
								<span class="text-20 text-white">0.5%{{$t('NUT.奖励.手续费')}}</span>
							</div>
						</div>
						<div class="mt-20 rounded-20 p-30" style="background-color: #0F0F10;">
							<div class="flex items-center justify-between ">
								<span class="text-26 text-white">{{$t('NUT.奖励.可领取')}}</span>
								<span class="text-28 text-success">4月 125%</span>
							</div>
							<div class="mt-20">
								<span class="text-44 text-white font-bold">125.5 ROON</span>
							</div>
							<div class="mt-20">
								<span class="text-24 text-white">{{$t('NUT.奖励.已领取')}}： 450.2 ROON</span>
							</div>
						</div>
						<div class="mt-20 rounded-20 flex items-center justify-between">
							<span class="text-28 text-#999">{{$t('NUT.奖励.我的流动性')}}</span>
							<span class="text-28 text-#999">100,000 NUT</span>
						</div>
						<div class="mt-20 rounded-20 flex items-center justify-between">
							<span class="text-28 text-#999">{{$t('NUT.奖励.池份额')}}</span>
							<span class="text-28 text-primary">0.15%</span>
						</div>
						<div class="mt-30 px-20 h-60 rounded-12 flex items-center justify-center border border-solid"
							style="border-color:#EB470C; background-color: #EB470C20;">
							<span
								class="ml-20 text-20 text-primary">{{$t('NUT.奖励.LP每小时自动撤出0.25%，0.125%燃烧，0.125%分红')}}</span>
						</div>
						<div class="mt-20 flex items-center justify-between">
							<div @click="showAmountPopup = true"
								class="w-630 h-100 bg-primary/20 rounded-full flex items-center justify-center mr-10">
								<span class="text-32 text-primary">{{$t('NUT.奖励.添加流动性')}}</span>
							</div>
							<div class="w-630 h-100 bg-primary rounded-full flex items-center justify-center ml-10">
								<span class="text-32 text-white">{{$t('NUT.奖励.领取奖励')}}</span>
							</div>
						</div>
					</div>
				</div>
				<!-- NFT分红 -->
				<div v-else-if="queryInfo.type == 4" class="">
					<div class="bg-white/10 rounded-20 p-30">
						<div class="flex items-center justify-between">
							<span class="text-36 text-white">{{$t('NUT.奖励.NFT资产分红')}}</span>
							<div class="px-20 h-42 rounded-12 flex items-center justify-center border border-solid"
								style="border-color:#50B428; background-color: #50B42820;">
								<span class="text-20 text-white">0.5%{{$t('NUT.奖励.盈利税')}}</span>
							</div>
						</div>
						<div class="mt-20 flex items-center justify-between">
							<div class="rounded-20 p-30 mr-10" style="background-color: #0F0F10;">
								<div class="flex items-center ">
									<img class="w-50 h-50" src="@/assets/images/pages/nut-reward/jd.png" alt="" />
									<span class="ml-10 text-28 text-white">{{$t('NUT.奖励.节点NFT')}}</span>
								</div>
								<div class="mt-20">
									<span class="text-40 text-white font-bold">125.5 ROON</span>
								</div>
								<div class="mt-20">
									<span class="text-24 text-white">{{$t('NUT.奖励.持有')}} 2{{$t('NUT.奖励.个')}}</span>
								</div>
							</div>
							<div class="rounded-20 p-30 ml-10" style="background-color: #0F0F10;">
								<div class="flex items-center ">
									<img class="w-50 h-50" src="@/assets/images/pages/nut-reward/bmd.png" alt="" />
									<span class="ml-10 text-28 text-white">{{$t('NUT.奖励.白名单NFT')}}</span>
								</div>
								<div class="mt-20">
									<span class="text-40 text-white font-bold">125.5 ROON</span>
								</div>
								<div class="mt-20">
									<span class="text-24 text-white">{{$t('NUT.奖励.持有')}} 2{{$t('NUT.奖励.个')}}</span>
								</div>
							</div>
						</div>
						
						<div class="mt-20 rounded-20 p-30" style="background-color: #0F0F10;">
							<div class="px-10 flex items-center justify-between">
								<span class="text-28 text-white">{{$t('NUT.奖励.NFT分红规则')}}</span>
							</div>
							<div class="mt-20 rounded-20 px-20">
								<div class="py-10 flex items-center">
									<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
									<span class="ml-20 text-24 text-#ccc">{{$t("NUT.奖励.节点NFT:50%分红(权重值分配)")}}</span>
								</div>
								<div class="py-10 flex items-center">
									<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
									<span class="ml-20 text-24 text-#ccc">{{$t("NUT.奖励.白名单NFT:50%分红(加权平均)")}}</span>
								</div>
								<div class="py-10 flex items-center">
									<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
									<span class="ml-20 text-24 text-#ccc">{{$t("NUT.奖励.激活条件: 持币≥100.000 NUT")}}</span>
								</div>
							</div>
						</div>
						<div class="mt-30 px-20 h-60 rounded-12 flex items-center justify-center border border-solid"
							style="border-color:#EB470C; background-color: #EB470C20;">
							<img class="w-24 h-24" src="@/assets/images/pages/nut-reward/ts.png" alt="" />
							<span class="ml-20 text-20 text-primary">{{$t('NUT.奖励.领取时50%销毁，50%到账')}}</span>
						</div>
						<div class="mt-20 flex items-center justify-center">
							<div class="w-630 h-100 bg-primary rounded-full flex items-center justify-center ml-10">
								<span class="text-32 text-white">{{$t('NUT.奖励.领取全部NFT奖励')}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template v-slot:menuBar>
			<menu-bar-nut activeMenu="nut-reward"></menu-bar-nut>
		</template>
		<template v-slot:popup>
			<van-popup v-model="showAmountPopup" position="center" round>
				<div class="w-690">
					<div class="bg-#0F0F17 rounded-20 w-690 relative pt-100 pb-30 px-30" style="margin-top: -98rem;">
						<div class="flex items-start justify-between mt-20">
							<div class="flex items-center">
								<img class="w-76 h-76" src="@/assets/images/pages/nut-reward/tjldx.png" alt="" />
								<div class="ml-20">
									<div>
										<span class="text-36 text-white">{{$t("NUT.奖励.添加流动性")}}</span>
									</div>
									<div>
										<span class="text-26 text-#999">NUT/ROON{{$t("NUT.奖励.流动性池")}}</span>
									</div>
								</div>
							</div>
							<img @click="showAmountPopup = false" class="w-40 h-40"
								src="@/assets/images/pages/usdr-swap/icon_gb.png" alt="" />
						</div>
						<div class="mt-30 px-20 h-60 rounded-12 flex items-center justify-center border border-solid"
							style="border-color:#EB470C; background-color: #EB470C20;">
							<img class="w-24 h-24" src="@/assets/images/pages/nut-reward/ts.png" alt="" />
							<span class="ml-20 text-20 text-primary">{{$t('NUT.奖励.当前池子比例')}}：</span>
							<span class="text-20 text-primary">1NUT = 1,000 ROON</span>
						</div>
						<div class="flex items-center justify-between mt-20">
							<span class="text-26 text-#999">RUT {{$t("NUT.奖励.数量")}}</span>
							<span class="text-26 text-white">{{$t("NUT.奖励.余额")}} 3.500</span>
						</div>
						<div class="h-110 rounded-18 bg-#1B1B1B flex items-center justify-between mt-20 mx-20 px-30">
							<input class="w-300 text-32 text-white" type="text" inputmode="decimal"
								:placeholder="$t('NUT.奖励.请输入NUT数量')" />
							<img class="w-50 h-50" src="@/assets/images/pages/swap/roon.png" alt="" />
							<div
								class="ml-20 flex-shrink-0 rounded-18 bg-white/10 flex items-center justify-center h-70 px-30">
								<span class="text-30 text-white">{{$t('NUT.奖励.最大')}}</span>
							</div>
						</div>
						<div class="flex items-center justify-center">
							<img class="w-160 h-160" src="@/assets/images/pages/nut-reward/add.png" alt="" />
						</div>
						<div class="flex items-center justify-between mt-20">
							<span class="text-26 text-#999">ROON {{$t("NUT.奖励.数量")}}</span>
							<span class="text-26 text-white">{{$t("NUT.奖励.余额")}} 3.500</span>
						</div>
						<div class="h-110 rounded-18 bg-#1B1B1B flex items-center justify-between mt-20 mx-20 px-30">
							<input class="w-300 text-32 text-white" type="text" inputmode="decimal"
								:placeholder="$t('NUT.奖励.请输入ROON数量')" />
							<img class="w-50 h-50" src="@/assets/images/pages/swap/roon.png" alt="" />
							<div
								class="ml-20 flex-shrink-0 rounded-18 bg-white/10 flex items-center justify-center h-70 px-30">
								<span class="text-30 text-white">{{$t('NUT.奖励.最大')}}</span>
							</div>
						</div>
						<div class="flex items-center justify-between mt-20">
							<span class="text-26 text-#999">{{$t("NUT.奖励.花店容差")}}</span>
						</div>
						<div class="mt-20 flex items-center justify-between">
							<div @click="selectAmount(item.num)" v-for="(item, index) in numberList" :key="index"
								:class="[form.amount == item.num ? 'bg-primary text-white' : 'bg-#1B1B1B text-#ccc']"
								class="w-150 h-80 rounded-20 flex items-center justify-center ">
								<span class="text-28">{{item.num}}%</span>
							</div>
							<div class="w-150 h-80 rounded-20 flex items-center justify-center bg-#1B1B1B text-#ccc">
								<input class="text-28 text-center flex-1" type="text" :placeholder="$t('NUT.奖励.自定义')" />
							</div>
						</div>
						<div class="mt-40 flex items-center justify-between">
							<div @click="showAmountPopup = false"
								class="w-294 h-100 bg-primary rounded-full flex items-center justify-center"
								style="background-color: #333;">
								<span class="text-32 text-white">{{$t('NUT.奖励.取消')}}</span>
							</div>
							<div class="w-294 h-100 bg-primary rounded-full flex items-center justify-center">
								<span class="text-32 text-white">{{$t('NUT.奖励.领取全部NFT奖励')}}</span>
							</div>
						</div>
					</div>
				</div>
			</van-popup>

		</template>
	</page-content>
</template>

<script>
	import {
		ajaxData
	} from "@/request/ajax";
	import homeNav from '@/components/home-nav/home-nav.vue';
	import menuBarNut from '@/components/menu-bar-nut/menu-bar-nut.vue';
	import router from "@/router";
	import utils from "@/utils/utils.js";
	import store from "@/store/index.js";
	import PledgeAbi from "@/abi/PledgeAbi"
	import erc20Abi from "@/abi/erc20Abi"
	import Mining_Abi from "@/abi/MiningAbi";
	import {
		getShowAddress,
		setShowAddress
	} from "@/libs/util";
	import Web3 from "web3";
	export default {
		components: {
			homeNav,
			menuBarNut,
		},
		data() {
			return {
				triggered: false,
				more: 1,
				typeList: [],
				queryInfo: {
					page: 1,
					type: 4
				},
				form: {
					type: 1,
					amount: 0,
					dd_roon: 0,
					amount_id: 0
				},
				numberList: [{
						id: 1,
						num: 0.1
					},
					{
						id: 2,
						num: 0.5
					},
					{
						id: 3,
						num: 1.0
					},
				],
				showAmountPopup: false
			};
		},
		computed: {
			lang() {
				return store.state.language;
			},
		},
		created() {},
		methods: {
			setQueryInfo(type) {
				this.queryInfo.type = type;
				this.form.type = type;
			},
			selectAmount(number) {
				let vm = this
				vm.form.amount = number;
				vm.form.amount = parseFloat(vm.form.amount)
				console.log(vm.roon_price)
				vm.form.dd_roon = (vm.form.amount * vm.roon_price).toFixed(2);
				// this.showAmountPopup = false;
			},
			scrolltolower() {
				console.log("滚动到底部/右边");
				this.triggered = true;
				setTimeout(() => {
					this.more = 0;
					this.triggered = false;
				}, 1000)
			},
			refresherpulling() {
				this.triggered = true;
				setTimeout(() => {
					this.triggered = false;
				}, 200)
				console.log("下拉刷新");
			}
		},
	};
</script>

<style scoped>
	.destroy-team-item1-bg-image {
		width: 690rem;
		height: 300rem;
		background-image: url("~@/assets/images/pages/destroy-team/itemBg.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}
</style>